import { createFeatureSelector, createSelector } from '@ngrx/store'

import { PROFILE_ADMIN_FEATURE_KEY, ProfileAdminState } from './profile-admin.reducer'

export const selectState = createFeatureSelector<ProfileAdminState | undefined>(PROFILE_ADMIN_FEATURE_KEY)

export const selectAddPersonContext = createSelector(
  selectState,
  (state: ProfileAdminState | undefined) => state?.addPersonContext
)

export const selectRemoveAccessContext = createSelector(
  selectState,
  (state: ProfileAdminState | undefined) => state?.removeAccessContext
)

export const selectEditRolesPermissionsContext = createSelector(
  selectState,
  (state: ProfileAdminState | undefined) => state?.editRolesPermissionsContext
)

export const selectSendMessageContext = createSelector(
  selectState,
  (state: ProfileAdminState | undefined) => state?.sendMessageContext
)

export const selectAddToGroupContext = createSelector(
  selectState,
  (state: ProfileAdminState | undefined) => state?.addToGroupContext
)

export const selectBuyMembershipContext = createSelector(
  selectState,
  (state: ProfileAdminState | undefined) => state?.buyMembershipContext
)
